module.exports = __webpack_public_path__ + "img/fastvaluedeal-cta.b2e2a882.png";